export default {
  title: {
    brand_index: "ブランド一覧"
  }
};
